import { Component } from "@angular/core";
import { ThemeService } from "../../../services/theme.service";
import { ThemeType } from "../../../models/theme.models";

@Component({
  selector: 'ui-theme-display',
  template: `
    <p>Current Theme: {{ theme }}</p>
  `
})
export class ThemeDisplayComponent {
  theme: ThemeType = ThemeType.Light;

  constructor(private themeService: ThemeService) {
    this.theme = this.themeService.getTheme();
  }
}
